import { DeviceType } from "@kuika/kuika-cl-model";
import { ResponsiveTypes } from "../../../components/design-tools/right-panel/properties-panel/responsive-design-toolkit";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface ResponsiveProviderState {
  setResponsiveRowColumnSettings: (
    colSizes: number[],
    kuikaId: string,
    deviceType: DeviceType,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => void;
  setColPropertiesForSmallSizes: (
    type: ResponsiveTypes,
    kuikaId: string,
    deviceType: DeviceType,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => void;
  resizeColumns: (
    rowKuikaId: string,
    columnIndex: number,
    size: number,
    rightSize: number,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => void;
  splitColumn: (
    rowKuikaId: string,
    columnIndex: number,
    size: number,
    rightSize: number,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => void;
}

export class ResponsiveProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  ResponsiveProviderState
> {
  static defaultState: ResponsiveProviderState = {
    setResponsiveRowColumnSettings: () => {},
    setColPropertiesForSmallSizes: () => {},
    resizeColumns: () => {},
    splitColumn: () => {}
  };

  getProviderValues = (): ResponsiveProviderState => {
    return {
      setResponsiveRowColumnSettings: this.setResponsiveRowColumnSettings,
      setColPropertiesForSmallSizes: this.setColPropertiesForSmallSizes,
      resizeColumns: this.resizeColumns,
      splitColumn: this.splitColumn
    };
  };

  setResponsiveRowColumnSettings = (
    colSizes: number[],
    kuikaId: string,
    deviceType: DeviceType,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => {
    this.partial.dragDrop.setColumnsNumber(colSizes, kuikaId, deviceType, isTabletDisable, isPhoneDisable);
  };

  setColPropertiesForSmallSizes = (
    type: ResponsiveTypes,
    kuikaId: string,
    deviceType: DeviceType,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => {
    this.partial.dragDrop.setColPropertiesForSmallSizes(type, kuikaId, deviceType, isTabletDisable, isPhoneDisable);
  };

  resizeColumns = (
    rowKuikaId: string,
    columnIndex: number,
    size: number,
    rightSize: number,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => {
    this.partial.dragDrop.resizeColumns(rowKuikaId, columnIndex, size, rightSize, isTabletDisable, isPhoneDisable);
  };

  splitColumn = (
    rowKuikaId: string,
    columnIndex: number,
    size: number,
    rightSize: number,
    isTabletDisable: boolean,
    isPhoneDisable: boolean
  ) => {
    this.partial.dragDrop.splitColumn(rowKuikaId, columnIndex, size, rightSize, isTabletDisable, isPhoneDisable);
  };
}
